import { apiClient } from '@/lib/api';
import type { PrimerosPasosDto } from '../lib/siguiente-paso';

/** L7 (vault 279): lo que cada empresa ajusta de Precios Dinámicos vive bajo esta ruta. */
const BASE = '/api/dynamic-pricing-setup';

/** Contrato de L2 (vault 280, D-L2-6): la precisión va en fracción (0,95). */
export interface PoliticaDeVinculacionDto {
  precisionObjetivo: number;
  minimoDeDecisiones: number;
}

export interface UmbralesDeAlertaDto {
  aviso: number;
  critico: number;
}

export interface AjustesDelModuloDto {
  categoryMarginRefs: Record<string, number>;
  freshnessDays: number;
  opportunityThresholdPct: number;
  autoLinkPolicy: PoliticaDeVinculacionDto;
  alertThresholds: UmbralesDeAlertaDto;
  nonComparableCategories: string[];
  esValorInicial: {
    freshnessDays: boolean;
    opportunityThresholdPct: boolean;
    autoLinkPolicy: boolean;
    alertThresholds: boolean;
  };
  baseCurrency: { code: string; symbol: string; name: string } | null;
}

export interface CambiosDeAjustesDto {
  categoryMarginRefs?: Record<string, number | null>;
  freshnessDays?: number | null;
  opportunityThresholdPct?: number | null;
  autoLinkPolicy?: PoliticaDeVinculacionDto | null;
  alertThresholds?: UmbralesDeAlertaDto | null;
  nonComparableCategories?: string[];
}

export interface CategoriaDeLaEmpresa {
  categoria: string | null;
  clave: string;
  productos: number;
  margenDeLaEmpresa: number | null;
  margenGeneral: number;
  noComparable: boolean;
}

export const altaDeClienteService = {
  getAjustes: () => apiClient.get<AjustesDelModuloDto>(`${BASE}/settings`),
  guardarAjustes: (cambios: CambiosDeAjustesDto) =>
    apiClient.put<AjustesDelModuloDto>(`${BASE}/settings`, cambios),
  getCategorias: () => apiClient.get<CategoriaDeLaEmpresa[]>(`${BASE}/categories`),
  getPrimerosPasos: () => apiClient.get<PrimerosPasosDto>(`${BASE}/first-steps`),
};
